<template>
	<v-container>
    <v-dialog v-model="showDialog" scrollable max-width="750px">
      <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
			<v-card v-if="!loading">
				<v-card-title style="padding: 5px 0 0 5px;">
					<v-col cols="12">
						<span style="font-size: 20px;">
							{{ $t('wkt.admin.calendar.add-holidays-window.title') }}
						</span>
						<!--<v-btn icon style="top: -20px; left: 10px; float: right;">
							<v-icon @click="showDialog=false">close</v-icon>
						</v-btn>-->
					</v-col>
				</v-card-title>
				<v-card-text style="padding-bottom: 0;">
					<v-container class="pt-0" @wheel="onWheel">
						<v-form ref="form">
							<v-row style="margin-top: 10px;">
								<v-col cols="12" class="pa-0">
									<v-autocomplete
										attach
										v-model="countryId"
										:items="countries"
										:item-text="locale"
										item-value="alpha2"
										menu-props="bottom, offsetY"
										:label="$t('wkt.admin.calendar.add-holidays-window.select_country')"
										@change="updateStates()" />
								</v-col>
								<v-col cols="12" class="pa-0">
									<v-autocomplete
										attach
										v-model="stateId"
										:items="states"
										item-text="name"
										item-value="code"
										menu-props="bottom, offsetY"
										:label="$t('wkt.admin.calendar.add-holidays-window.select_state')"
										:disabled="!countryId" />
								</v-col>
								<v-col cols="12" class="mt-4 pa-0 d-flex">
									<v-row>
										<v-col cols="6">
										<v-menu
										:close-on-content-click="true"
										transition="scale-transition"
										offset-y
										min-width="290px">
											<template v-slot:activator="{ on }">
													<v-text-field
													v-model="date1"
													:label="$t('wkt.admin.calendar.add-holidays-window.start_date')"
													readonly
													v-on="on"
													dense
													:rules="[validationRules.required]" />
											</template>
											<v-date-picker
												v-model="isoDate1"
												no-title
												scrollable
												:locale="locale"
												:min="calendar ? `${calendar.exerciseMin}-01-01` : null"
												:max="calendar ? `${calendar.exerciseMax}-12-31` : null"
											></v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="6">
										<v-menu
										:close-on-content-click="true"
										transition="scale-transition"
										offset-y
										min-width="290px">
											<template v-slot:activator="{ on }">
													<v-text-field
													v-model="date2"
													:label="$t('wkt.admin.calendar.add-holidays-window.end_date')"
													readonly
													v-on="on"
													dense
													:rules="[validationRules.required]" />
											</template>
											<v-date-picker
												v-model="isoDate2"
												no-title
												scrollable
												:locale="locale"
												:min="calendar ? `${calendar.exerciseMin}-01-01` : null"
												:max="calendar ? `${calendar.exerciseMax}-12-31` : null"
											></v-date-picker>
										</v-menu>
									</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-0 d-flex align-center">
									<v-btn 
										color="#185EA9" 
										class="white--text"
										:disabled="!countryId || !stateId"
										@click="getHolidays()">
										{{ $t('wkt.admin.calendar.add-holidays-window.get_holidays') }}
									</v-btn>
									<span class="pl-4 my-4">
										{{ $t('wkt.admin.calendar.add-holidays-window.holidays_found', [holidays.length]) }}
									</span>  
								</v-col>
								<v-col cols="12" class="mb-4 pa-0">
									<span class="my-4 text-subtitle-1">
										{{ $t('wkt.admin.calendar.add-holidays-window.select_holidays_to_add', [selected.length]) }}
									</span>
									<v-data-table
										v-model="selected"
										:headers="headers"
										:items="holidays"
										:loading-text="$t('wkt.admin.common.table.loading')"
										:no-data-text="$t('wkt.admin.common.table.no_data')"
										:no-results-text="$t('wkt.admin.common.table.no_results')"
										:fixedHeader="true"
										disable-pagination
										hide-default-footer
										show-select
										checkbox-color="#185EA9"
										height="300px"
										class="elevation-0"
									>
										<template v-slot:[`item.date`]="{ item }">
											<span>{{ formatOnlyDate(item.msDate) }}</span>
										</template>
										<template v-slot:[`item.type`]="{ item }">
											<span v-if="item.type === 2">
												{{ $t('wkt.admin.calendar.add-holidays-window.holiday_type_national') }}
											</span>
											<span v-if="item.type === 3">
												{{ $t('wkt.admin.calendar.add-holidays-window.holiday_type_local') }}
											</span>
											<span v-if="item.type === 4">
												{{ $t('wkt.admin.calendar.add-holidays-window.holiday_type_other') }}
											</span>
										</template>
									</v-data-table> 
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn :disabled="holidays.length === 0" color="#185EA9" text @click="selectHolidays()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.calendar.add-holidays-window.reset_to_default_selected').toUpperCase() }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn :disabled="date1 && date2 && selected.length === 0" color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.import').toUpperCase() }}</v-btn>
					<v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>	

		<v-snackbar
		v-model="showAlert"
		:timeout="alertTimeout"
		:color="alertColor">
				<span style="color: #ffffff;">{{alertText}}</span>
				<v-btn text @click="showAlert=false">
				<span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
				</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import BaseModule from '../../common/BaseModule.js';
import api from '../../../api/worktime.js';
import gwt from '../../../api/gwt.js';
import jsonCountries from '@/countries/world.json';
import jsonStates from '@/countries/subdivisions.json';
import { EventBus } from '../../util/event-bus';

  export default {
    name: 'AddCalendarHolidaysDialog',
    mixins: [BaseModule],
		components: {
		},
    data () {
      return {
				loading: false,
				calendar: null,
        locale: null,
				countryId: null,
				countries: [],
				stateId: null,
        states: [],
				date1: null,
				isoDate1: null,
				date2: null,
				isoDate2: null,
				allHolidays: [],	
				holidays: [],	
        selected: [],			
        headers: [
          { text: this.$t('wkt.admin.calendar.add-holidays-window.table.headers.date'), value: 'date', sortable: false, width: '15%' },
          { text: this.$t('wkt.admin.calendar.add-holidays-window.table.headers.name'), value: 'name', sortable: false, width: '65%' },
          { text: this.$t('wkt.admin.calendar.add-holidays-window.table.headers.type'), value: 'type', sortable: false, width: '20%' },
        ],
        showAlert: false,
        alertColor: 'error',
        alertText: '',
        alertTimeout: 3000,
        showDialog: false,
      }
    },
    methods: {
		onWheel(event) {
			event.stopPropagation();
		},
			onReveal: function(calendar) {				
        this.calendar = calendar;
				this.open();
			},
      open: function() {
				if (this.$refs.form) {
					this.$refs.form.resetValidation();
				}

				this.countryId = null;
				this.countries = jsonCountries;
				this.stateId = null;
				this.states = jsonStates;
				this.states = [];
				this.allHolidays = [];
				this.holidays = [];
				this.selected = [];

				const today = new Date();
				const year = today.getFullYear();
				const month = today.getMonth() + 1;

				this.isoDate1 = `${year}-${month < 10 ? `0${month}` : month}-01`;
				this.isoDate2 = `${year}-${month < 10 ? `0${month}` : month}-${new Date(year, month, 0).getDate()}`;
				
				this.date1 = this.formatOnlyDate(this.isoDate1);
				this.date2 = this.formatOnlyDate(this.isoDate2);
				
        this.showDialog = true;

				this.loading = true;

				api.getCountry(gwt.getSessionInformation().company.countryId,
					res => {
						this.loading = false;
						//console.log(`*** Country: ${JSON.stringify(res)}`);
						this.locale = res.locale;
					},
					error => {
						this.loading = false;
						this.$log.error(error);
					});
      },
			updateStates() {
				this.states = jsonStates.filter(x => x.country.toUpperCase() === this.countryId.toUpperCase());
			},
			getHolidays() {
				this.loading = true;

				let year = new Date(this.isoDate1).getFullYear();
				let numYears = (new Date(this.isoDate2).getFullYear() - new Date(this.isoDate1).getFullYear()) + 1;

				this.allHolidays = [];
				
				this.doRequestHolidays(year, numYears - 1);
			},
			doRequestHolidays(year, numYears) {
				api.getCalendarHolidays(this.countryId, this.stateId.toLowerCase(), this.locale, year,
					res => {
						this.loading = false;
						this.allHolidays = [...this.allHolidays, ...res.response.holidays];
						if (numYears > 0) {
							this.doRequestHolidays(year + 1, numYears - 1);
							return;
						}
						//console.log(`*** allHolidays: (${this.allHolidays.length}) ${this.allHolidays.map(h => h.name)}`);
						this.filterHolidays();
						this.selectHolidays();
					},
					error => {
						this.loading = false;
						this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
					});
			},
			filterHolidays() {
				this.allHolidays.forEach((h, index) => {
					h.id = index;
					h.msDate = new Date(h.date.iso).getTime();
					if (this.isNationalHoliday(h)) {
						h.type = 2; // NATIONAL_HOLIDAY = 2
					} else if (this.isLocalHoliday(h)) {
						h.type = 3; // LOCAL_HOLIDAY = 3
					} else if (this.isOtherHoliday(h)) {
						h.type = 4; // COMPANY_HOLIDAY = 4
					} else {
						h.type = -1;
					}
				});

				const me = this;
				
				this.holidays = this.allHolidays.filter(h => {
					const condition1 = h.type !== -1;
					const dt = new Date(h.date.iso).getTime();
					const dt1 = new Date(me.isoDate1).getTime();
					const dt2 = new Date(me.isoDate2).getTime();
					const condition2 = dt >= dt1 && dt <= dt2; 
					return condition1 && condition2;
				});					
				//this.holidays = this.allHolidays.filter(h => this.isNationalHoliday(h) || this.isLocalHoliday(h) || this.isOtherHoliday(h));					
				//console.log(`*** holidays: (${this.holidays.length}) ${this.holidays.map(h => h.name)}`);
			},
			isNationalHoliday(item) {
				return item.type.some(h => h.toUpperCase().indexOf('NATIONAL') === 0);
			},
			isLocalHoliday(item) {
				return item.type.some(h => h.toUpperCase().indexOf('LOCAL') === 0);
			},
			isOtherHoliday(item) {
				return item.type.some(h => h.toUpperCase().indexOf('OBSERVANCE') === 0);
			},
			selectHolidays() {
				this.selected = [];
				this.holidays.forEach(h => {
					if (h.type === 2 || h.type === 3) {
						this.selected.push(h);
					}
				});
			},
      ok: function() {
				if (!this.$refs.form.validate()) {
					return;
				}

				this.loading = true;

				let data = {
					calendarId: this.calendar.id,
					holidays: []
				};

				this.selected.forEach(h => {
					data.holidays.push({ date: h.msDate, name: h.name.trim(), type: h.type });
				});
				
				api.addCalendarHolidays(data,
					res => {
						this.loading = false;
            if (res.rsOK) {
							this.showDialog = false;
							this.doShowAlert({ text: res.message, color: 'success', timeout: 3000 });
							EventBus.$emit('widget-data-click', { mode: '', type: 'CALENDAR', action: 'UPDATE', payload: JSON.stringify(this.calendar.id) });
						} else {
							this.doShowAlert({ text: res.message, color: 'error', timeout: 3000 });
						}
					},
					error => {
						this.loading = false;
						this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
					});
      },
			doShowAlert (payload) {
				this.alertText = payload.text;
				this.alertColor = payload.color;
				this.alertTimeout = payload.timeout;
				this.showAlert = true;
			},
    },
		watch: {
			isoDate1 (val) {
        this.date1 = this.formatOnlyDate(val);
      },
			isoDate2 (val) {
        this.date2 = this.formatOnlyDate(val);				
			}
		}
  }
</script>